export default "__VITE_ASSET__8b93a450__"